import { useState } from 'react';

import { useIntl } from 'react-intl';
import { Button, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { WarningIcon } from 'assets/icons';
import { useAxios } from 'configs/requests';
import { Loading } from 'components/Fetch';
import { CheckIcon } from 'assets/icons';
import { ToastNotificationContent } from 'components/UI';

interface IActivateSimModalProps {
  device: IDeviceListItem;
  onClose: () => void;
}

const ActivateSimModal = ({ device, onClose }: IActivateSimModalProps) => {
  const { formatMessage } = useIntl();
  const [iccid, setIccid] = useState('');

  const [{ loading }, postActivateSim] = useAxios(
    {
      url: `/clinician-gateway/device/${device.deviceId}/activate-sim`,
      method: 'POST'
    },
    { manual: true }
  );

  const handleSubmit = async () => {
    if (!iccid.trim()) return;
    try {
      await postActivateSim({ data: { iccid: iccid.trim() } });
      toast(
        <ToastNotificationContent
          icon={<CheckIcon className="icon" />}
          text="activateSimSuccessKey"
        />
      );
      onClose();
    } catch {
      toast.error(
        <ToastNotificationContent icon={<WarningIcon className="icon" />} text="error" />
      );
    }
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({ id: 'activateSimKey' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loading />}
        <Form.Group>
          <Form.Label>{formatMessage({ id: 'activateSimIccidLabelKey' })}</Form.Label>
          <Form.Control
            type="text"
            value={iccid}
            onChange={(e) => setIccid(e.target.value)}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onClose}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!iccid.trim() || loading}>
          {formatMessage({ id: 'activateKey' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ActivateSimModal;
